export default __webpack_public_path__ + "static/media/Measurements.ab1851be.svg";